/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Children_P2Inputs */

const es_privacy_policy_children_p2 = /** @type {(inputs: Privacy_Policy_Children_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si descubrimos que hemos recopilado informacion de un menor sin verificacion de consentimiento parental valido, la eliminaremos de inmediato. Si usted es padre o madre y cree que su hijo nos ha proporcionado informacion, contactenos en privacy@nexata.app.`)
};

const en_privacy_policy_children_p2 = /** @type {(inputs: Privacy_Policy_Children_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If we discover we have collected information from a minor without valid parental consent verification, we will delete it immediately. If you are a parent and believe your child has provided us with information, contact us at privacy@nexata.app.`)
};

/**
* | output |
* | --- |
* | "If we discover we have collected information from a minor without valid parental consent verification, we will delete it immediately. If you are a parent and..." |
*
* @param {Privacy_Policy_Children_P2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_children_p2 = /** @type {((inputs?: Privacy_Policy_Children_P2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Children_P2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_children_p2(inputs)
	return en_privacy_policy_children_p2(inputs)
});
export { privacy_policy_children_p2 as "privacy_policy.children.p2" }